<div class="dashboard-layout flex items-stretch h-full">
  <!-- Small screens: the side nav opens and pushes the page over, toggled by this checkbox.
       The no-op (change) binding makes Angular refresh the menu/close icon. -->
  <input
    #sideNavToggle
    type="checkbox"
    id="side-nav-toggle"
    class="side-nav-toggle"
    (change)="(0)"
  />
  <label for="side-nav-toggle" class="side-nav-burger" aria-label="Menu">
    <mat-icon>{{ sideNavToggle.checked ? "close" : "menu" }}</mat-icon>
  </label>

  <gbui-side-nav class="navbar">
    <gbui-side-nav-menu (click)="sideNavToggle.checked = false">
      <div class="logo-container">
        <img src="/assets/logo/check+plus.png" alt="" />
      </div>

      <section class="side-nav-section">
        <!-- 
        **
        * Company manager side nav
        *
       -->
        <ng-container
          *ngIf=" role === 'company-administrator' && isAdmin === true"
        >
          <ul
            class="side-nav-ul"
            *ngFor="let item of companyManager"
            [ngClass]="{overlay: companyManagerRoutes(itemSelected)}"
          >
            <li
              [routerLink]="[item.route]"
              class="father"
              [ngClass]="{'active-route': companyManagerRoutes(itemSelected)}"
            >
              {{item.name}}
            </li>
            <ul
              class="list"
              [ngClass]="{'drop-down': companyManagerRoutes(itemSelected)}"
            >
              <li
                *ngFor="let children of item.childrens"
                [routerLink]="[children.route]"
                routerLinkActive="active-route"
              >
                {{children.name}}
              </li>
            </ul>
            <li
              class="home-switch"
              (click)="changeToRegularUser()"
              class="father"
            >
              <label for=""> Home </label>
            </li>
          </ul>
        </ng-container>

        <!-- 
        **
        * Regular User side nav
        *
       -->
        <ng-container *ngIf="  isAdmin === false && role !== 'super-admin'  ">
          <ul
            class="side-nav-ul"
            *ngFor="let item of regularUser"
            [ngClass]="{overlay:regularUserRoutes(itemSelected)}"
          >
            <li
              [routerLink]="[item.route]"
              class="father"
              [ngClass]="{'active-route': regularUserRoutes(itemSelected)}"
            >
              {{item.name}}
            </li>
            <ul
              class="list"
              [ngClass]="{'drop-down': regularUserRoutes(itemSelected)}"
            >
              <li
                *ngFor="let children of item.childrens"
                [ngClass]="{'disable-content': children.name === 'Request' && isExpired  || children.name === 'Approve' && isExpired }"
                [routerLink]="[children.route]"
                routerLinkActive="active-route"
              >
                {{children.name}}
              </li>
            </ul>
          </ul>
        </ng-container>

        <!-- 
        **
        * Super Admin side nav
        *
       -->
        <ng-container *ngIf="role === 'super-admin'">
          <ul
            class="side-nav-ul"
            *ngFor="let item of superAdmin"
            [ngClass]="{overlay:superAdminRoutes(itemSelected)}"
          >
            <li
              routerLinkActive="active-route"
              [routerLink]="[item.route]"
              class="father"
            >
              {{item.name}}
            </li>
            <ul
              class="list"
              [ngClass]="{'drop-down': superAdminRoutes(itemSelected)}"
            >
              <li
                *ngFor="let children of item.childrens"
                [routerLink]="[children.route]"
                routerLinkActive="active-route"
              >
                {{children.name}}
              </li>
            </ul>
          </ul>
        </ng-container>
      </section>

      <section class="log-out-item">
        <label for="" (click)="logOut()">Logout</label>
      </section>
    </gbui-side-nav-menu>
  </gbui-side-nav>
  <div
    class="router-wrapper"
    [ngClass]="{'on-banner-padding':isExpired  && onMembershipModule()}"
  >
    <div
      *ngIf="(isExpired) && onMembershipModule()"
      class="banner"
      (click)="navigateToMemberships()"
      [routerLink]="['/dashboard/membership']"
    >
      <div class="banner-inner">
        <p class="p-2">
          Your subscription have expired, please renew it in order to avoid
          account deletion
        </p>
        <button
          mat-icon-button
          color="primary"
          aria-label="Example icon button with a home icon"
        >
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>

    <router-outlet></router-outlet>
  </div>
</div>
